import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import cEnPng from '@/assets/landing/spreadsheet-activity/c_en.png'

const schema: LandingScreenSchema = {
	config: {
		funnelFeatureFlag: 'creatives_demgen',
	},

	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('female_activity.pages.landing.step_1.title'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
			uppercase: true,
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => {
			return {
				img: cEnPng,
				customStyles: {
					height: '40vh',
					marginTop: 'var(--size-24)',
					marginBottom: 'var(--size-24)',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
